<div class="container mt-5">
  
  <div class="header"><p class="appname">Listado de Logs de Carga</p></div>
  
  <table class="table table-striped font-text" aria-label="Elements">
    <thead>
        <tr>
          <th id="id">Id</th>
          <th id="categoryId">Category ID</th>
          <th id="poisCount">Pois Count</th>
          <th id="status">Status</th>
          <th id="message">Message</th>
          <th id="createdAt">Created At</th>
          <th id="updatedAt">Updated At</th>
          <th id="deletedAt">Deleted At</th>
        </tr>
    </thead>
    <tbody class="font-text">
      <tr *ngFor="let situation of data">
        <td>{{situation.id}}</td>
        <td>{{situation.categoryId}}</td>
        <td>{{situation.poisCount}}</td>
        <td>{{situation.status}}</td>
        <td>{{situation.message}}</td>
        <td>{{situation.createdAt | slice:0:10}} {{situation.createdAt | slice:11:16}}</td>
        <td>{{situation.updatedAt | slice:0:10}} {{situation.updatedAt | slice:11:16}}</td>
        <td>{{situation.deletedAt | slice:0:10}} {{situation.deletedAt | slice:11:16}}</td>
      </tr>
    </tbody>
  </table>

  <mat-dialog-actions align="end">
    <button mat-button  class="font-text" (click)="closeDialog()">Cerrar</button>
  </mat-dialog-actions>
</div>